/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ledger_Query_TitleInputs */

const en_ledger_query_title = /** @type {(inputs: Ledger_Query_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Source query`)
};

const nl_ledger_query_title = /** @type {(inputs: Ledger_Query_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bronquery`)
};

/**
* | output |
* | --- |
* | "Source query" |
*
* @param {Ledger_Query_TitleInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const ledger_query_title = /** @type {((inputs?: Ledger_Query_TitleInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ledger_Query_TitleInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_ledger_query_title(inputs)
	return en_ledger_query_title(inputs)
});